import { render, staticRenderFns } from "./product_regulatory_information.vue?vue&type=template&id=899c8072&scoped=true&"
import script from "./product_regulatory_information.vue?vue&type=script&lang=js&"
export * from "./product_regulatory_information.vue?vue&type=script&lang=js&"
import style0 from "./product_regulatory_information.vue?vue&type=style&index=0&id=899c8072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899c8072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('899c8072')) {
      api.createRecord('899c8072', component.options)
    } else {
      api.reload('899c8072', component.options)
    }
    module.hot.accept("./product_regulatory_information.vue?vue&type=template&id=899c8072&scoped=true&", function () {
      api.rerender('899c8072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_regulatory_information.vue"
export default component.exports